import React, { useState } from "react";
// import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Modal, PageHeader } from 'antd';
import { faArrowLeft, faArrowRightLong, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from 'react-bootstrap/Card';
import { Tabs } from "antd";
import { NavLink, useNavigate } from "react-router-dom/dist";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import CompanyMeetingIcon from "../../assets/images/icons/company_meeting_icon.png"
import EVotingIcon from "../../assets/images/icons/evoting_icon.png"
import DirectorshipIcon from "../../assets/images/icons/directorship_icon.png"
import AdvisoryServiceIcon from "../../assets/images/icons/advisory_service_icon.png"
import { Col, Container, Row } from "react-bootstrap";
import InnerHeading from "../components/InnerHeading/InnerHeading";

const localizer = momentLocalizer(moment);
const { TabPane } = Tabs;

const Directorship = () => {

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("Upcoming");

    const tabs = [
        { name: "Upcoming" },
        { name: "Archived" }
    ];


    const data = [
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "10 Participants"
        },
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "8 Participants"
        },
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "8 Participants"

        }

    ]

    let headerData = [{
        name: "Company Meeting & Announcements",
        route: "/E-service/CompanyMeeting&Announcements",
        imgSrc: CompanyMeetingIcon
    }, {
        name: "E-Voting / E-Meeting",
        route: "/E-service/E-Voting",
        imgSrc: EVotingIcon
    }
        , {
        name: "Directorship",
        route: "/E-service/Directorship",
        imgSrc: DirectorshipIcon
    }
        , {
        name: "Advisory Services",
        route: "/E-service/AdvisoryServices",
        imgSrc: AdvisoryServiceIcon
    }
    ]

    return (
        <>




            <PageHeaderWithRoutes tabs={headerData} heading="E-Services" desc="Discover a range of e-services such as the AGM/EOGM Calendar, e-voting options, directorship resources, and advisory services. These tools are crafted to streamline governance tasks and empower informed decision-making for shareholders and issuers alike." />



            <div className="content_wrap">


                <div className="e_service">
                    <div className='container'>
                        <div className="cards_wrap">
                            <Container>
                                <Row>
                                    <InnerHeading heading="Directorship" text="Explore resources related to directorships, including responsibilities, best practices, and opportunities." />


                                    <h1 className="bold text-center my-5">Coming Soon</h1>
                                </Row>
                            </Container>

                        </div>
                    </div>




                </div>
            </div >


        </>
    );
};

export default Directorship;
